<div class="signup-container">
  <div class="right-section">
    <form class="signup-form" [formGroup]="signUpForm">
      <h3 class="form-title">{{ 'Sign up'|translate }}</h3>
      <div class="form-grid">
        <app-input
          class="mb-fill-row"
          [placeholder]="'Enter first name'|translate"
          formControlName="givenName"
          [title]="'First name'|translate"
          [pattern]="NAME_REGEX"
          [pastePattern]="PASTE_NAME_REGEX"
          [max]="50"
          [required]="true"
          [isSubmitRequired]="true"
          [isSubmitted]="isSubmitted"
        ></app-input>
        <app-input
          class="mb-fill-row"
          [placeholder]="'Enter last name'|translate"
          formControlName="familyName"
          [title]="'Last name'|translate"
          [pattern]="NAME_REGEX"
          [pastePattern]="PASTE_NAME_REGEX"
          [max]="50"
          [required]="true"
          [isSubmitRequired]="true"
          [isSubmitted]="isSubmitted"
        ></app-input>
        <app-input
          class="fill-row"
          [placeholder]="'Enter email'|translate"
          type="email"
          formControlName="email"
          [title]="'Email'|translate"
          autocomplete="email"
          [pattern]="EMAIL_INPUT_REGEX"
          [pastePattern]="PASTE_EMAIL_REGEX"
          [max]="255"
          [required]="true"
          [isSubmitRequired]="true"
          [isSubmitted]="isSubmitted"
        ></app-input>
        <app-input
          [placeholder]="'Enter password'|translate"
          type="password"
          formControlName="password"
          [title]="'Password'|translate"
          autocomplete="new-password"
          [max]="128"
          [required]="true"
          [isSubmitRequired]="true"
          [isSubmitted]="isSubmitted"
        ></app-input>
        <app-input
          [placeholder]="'Re-enter the password'|translate"
          type="password"
          formControlName="confirmPassword"
          [title]="'Confirm password'|translate"
          autocomplete="new-password"
          [max]="128"
          [required]="true"
          [isSubmitRequired]="true"
          [isSubmitted]="isSubmitted"
        ></app-input>
      </div>
      <app-password-validation [passwordRequirements]="passwordRequirements"></app-password-validation>
      <div class="franchise-wrapper">
        <app-franchise-input
          [title]="'Preferred location'|translate"
          [franchises]="frItems"
          (frChange)="selectLocation($event)"
        ></app-franchise-input>
      </div>
      <div class="signup-btn">
        <app-button
          type="submit"
          [ariaLabel]="'Sign up'|translate"
          [buttonStyleType]="ButtonTypes.PRIMARY_0"
          [disabled]="!formTouched || !arePasswordRequirementsMet"
          [buttonSize]="BUTTON_SIZE.FULL_SIZE"
          (click)="signUp()"
        >{{ 'Sign up'|translate }}
        </app-button>
      </div>
      <div class="login-container">
        <span>{{ 'Already have an account'|translate }}?</span>
        <span (click)="logIn()" class="login-btn">{{ 'Login'|translate }}</span>
      </div>
    </form>
  </div>
</div>
